const variableStyles = {
  // theme
  darkTheme: '#101222',
  lightTheme: '#FFFFFF',
};

export default variableStyles;